import React, { useState } from 'react';

export const HeadingLabelControl = ({field} : ControlParameters) : JSX.Element => {
  const [tag] = useState(field?.properties?.inputcontrolstyle ?? 'h2');

  return (
    <>
      {React.createElement(
        tag, 
        { className: `form-header__titel ${field?.properties?.fieldcssclass}` },
        field?.properties?.fieldcaption
      )}
    </>
  );
};